import mainCaller from '../mainCaller';

export async function getUsersList(token, query) {
  return await mainCaller(`admin/api/v1/members?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 선택한 회원 일괄 소프트 삭제(WITHDREW)
export async function deleteMembersBulk(memberIds, token) {
  return await mainCaller(`admin/api/v1/members`, 'DELETE', { memberIds }, {
    Authorization: `Bearer ${token}`,
  });
}


export async function getUnsubscribedUsersList(token, query) {
  return await mainCaller(`admin/api/v1/members/unsubscribed?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getSearchUsersList(token, body) {
  const { data } = await mainCaller(`admin/api/v1/members`, 'GET', body, {
    Authorization: `Bearer ${token}`,
  });
  return data;
}

export async function createCenterManager(token, body) {
  const { data } = await mainCaller(`admin/api/v1/center/managers`, 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
  return data;
}

// 엑셀 업로드로 기업회원(센터) 여러 건을 한 번에 생성
export async function bulkCreateCenterManagers(token, body) {
  const { data } = await mainCaller(`admin/api/v1/center/managers/bulk`, 'POST', body, {
    Authorization: `Bearer ${token}`,
  });
  return data;
}

export async function getAllManagerList(token, query) {
  return await mainCaller(`admin/api/v1/center/managers?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getMemberByTicket(token, query) {
  return await mainCaller(`admin/api/v1/search-options/members?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getMemberByBranch(token, query) {
  return await mainCaller(`admin/api/v1/search-options/branch/members?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getMemberByBranchAndTemporary(token, query) {
  return await mainCaller(`admin/api/v1/search-options/branch/temporary/members?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getManagerListDetail(token, id) {
  return await mainCaller(`admin/api/v1/center/managers/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateManager(token, id, data) {
  return await mainCaller(`admin/api/v1/center/managers/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function stopPassById(token, id, memberCoursePassId, data) {
  return await mainCaller(`admin/api/v1/members/${id}/passes/${memberCoursePassId}/stop`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function stopCancelPassById(token, id, memberCoursePassId) {
  return await mainCaller(`admin/api/v1/members/${id}/passes/${memberCoursePassId}/cancel-stop`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 이미 중지된(STOPPED) 이용권의 중지기간(중지 시작/종료일) 수정. 중지 횟수는 재차감되지 않는다.
export async function modifyStopPassById(token, id, memberCoursePassId, data) {
  return await mainCaller(`admin/api/v1/members/${id}/passes/${memberCoursePassId}/stop`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function stopTicketById(token, id, memberCourseTicketId, data) {
  return await mainCaller(`admin/api/v1/members/${id}/tickets/${memberCourseTicketId}/stop`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function stopCancelTicketById(token, id, memberCourseTicketId, data = null) {
  return await mainCaller(`admin/api/v1/members/${id}/tickets/${memberCourseTicketId}/cancel-stop`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 이미 중지된(STOPPED) 수강권의 중지기간(중지 시작/종료일) 수정. 중지 횟수는 재차감되지 않는다.
export async function modifyStopTicketById(token, id, memberCourseTicketId, data) {
  return await mainCaller(`admin/api/v1/members/${id}/tickets/${memberCourseTicketId}/stop`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}
export async function updateTicketInstructor(token, data) {
  return await mainCaller(`admin/api/v1/members/ticket/changeTrainer`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 일일권 담당강사 변경. member_trial_ticket 에는 강사 컬럼이 없어 수강권과 다른 엔드포인트를 쓴다.
export async function updateTrialTicketInstructor(token, memberId, memberTrialTicketId, data) {
  return await mainCaller(
    `admin/api/v1/members/${memberId}/trial-tickets/${memberTrialTicketId}/trainer`,
    'PUT',
    data,
    { Authorization: `Bearer ${token}` },
  );
}

export async function updateCenterPlanType(token, centerId, planType) {
  return await mainCaller(`admin/api/v1/centers/${centerId}/plan-type`, 'PATCH', { planType }, {
    Authorization: `Bearer ${token}`,
  });
}

// 시설 제어(IoT) 메뉴 노출 여부 — 매니저 계정은 재로그인 시점에 반영된다.
export async function updateCenterFacilityControl(token, centerId, facilityControlYn) {
  return await mainCaller(
    `admin/api/v1/centers/${centerId}/facility-control`,
    'PATCH',
    { facilityControlYn },
    { Authorization: `Bearer ${token}` },
  );
}

// 체크인앱(키오스크) 로그인 승인 여부 — 취소하면 다음 로그인(자동 갱신 포함)부터 차단된다.
export async function updateCenterKioskLogin(token, centerId, kioskLoginYn) {
  return await mainCaller(
    `admin/api/v1/centers/${centerId}/kiosk-login`,
    'PATCH',
    { kioskLoginYn },
    { Authorization: `Bearer ${token}` },
  );
}

// 골프 관리(타석 관리 메뉴·매장관리 골프 탭) 노출 여부 — 매니저는 재로그인 시점에 반영된다.
export async function updateCenterGolf(token, centerId, golfYn) {
  return await mainCaller(
    `admin/api/v1/centers/${centerId}/golf`,
    'PATCH',
    { golfYn },
    { Authorization: `Bearer ${token}` },
  );
}

// 수강권 자동 차감 설정 노출 여부 — 매니저는 재로그인 시점에 반영된다.
export async function updateCenterAutoDeduction(token, centerId, autoDeductionYn) {
  return await mainCaller(
    `admin/api/v1/centers/${centerId}/auto-deduction`,
    'PATCH',
    { autoDeductionYn },
    { Authorization: `Bearer ${token}` },
  );
}

// 회원앱 브랜딩(#188) — NONE(안 씀)/SELF(이 지점만)/GROUP(같은 본사 계열). GROUP 은 scope 로 직영점·가맹점 보이기
// scope: { showDirect?, showFranchise? } — 비운 값은 서버가 그대로 둔다
export async function updateCenterAppBranding(token, centerId, appBrandingType, scope = {}) {
  return await mainCaller(
    `admin/api/v1/centers/${centerId}/app-branding`,
    'PATCH',
    { appBrandingType, ...scope },
    { Authorization: `Bearer ${token}` },
  );
}

// 브랜드 앱 지점 배너(최대 3장, 장마다 링크 선택) — 회원앱 브랜드 홈 배너
export async function getCenterAppBanners(token, centerId) {
  return await mainCaller(`admin/api/v1/centers/${centerId}/app-banners`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateCenterAppBanners(token, centerId, banners) {
  return await mainCaller(
    `admin/api/v1/centers/${centerId}/app-banners`,
    'PUT',
    { banners },
    { Authorization: `Bearer ${token}` },
  );
}

// 라커 중지 — passId는 반드시 목록 응답의 stopTargetPassId를 사용해야 한다(대표 row가 만료건일 수 있음).
export async function stopLockerPassById(token, memberId, passId, data) {
  return await mainCaller(`admin/api/v1/members/${memberId}/locker-passes/${passId}/stop`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function stopCancelLockerPassById(token, memberId, passId, data = null) {
  return await mainCaller(`admin/api/v1/members/${memberId}/locker-passes/${passId}/cancel-stop`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 이미 중지된(STOPPED) 라커의 중지기간 수정. passId는 목록 응답의 stopTargetPassId 사용.
export async function modifyStopLockerPassById(token, memberId, passId, data) {
  return await mainCaller(`admin/api/v1/members/${memberId}/locker-passes/${passId}/stop`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 라커 자리 배정 / 자리 변경. 미배정 패스면 배정, 이미 배정돼 있으면 이동.
// dates({startDate, expireDate})를 같이 보내면 그 기간으로 바꿔서 배정한다(합치기).
// 같은 자리 다른 패스와 기간이 겹치면 406 + 안내 메시지가 온다.
export async function assignLockerPassSpot(token, memberId, passId, lockerId, dates) {
  return await mainCaller(
    `admin/api/v1/members/${memberId}/locker-passes/${passId}/locker`,
    'PUT',
    { lockerId, ...(dates || {}) },
    { Authorization: `Bearer ${token}` }
  );
}

// 한 자리의 이용권 배치를 통째로 확정 (합치기·기간 밀기).
// 하나씩 옮기면 중간 상태에서 겹쳐 거부되므로 최종 상태를 서버가 한 번에 검증한다.
export async function applyLockerPassPlan(token, memberId, lockerId, entries) {
  return await mainCaller(
    `admin/api/v1/members/${memberId}/locker-passes/plan`,
    'PUT',
    { lockerId, entries },
    { Authorization: `Bearer ${token}` }
  );
}

export async function unassignLockerPassSpot(token, memberId, passId) {
  return await mainCaller(`admin/api/v1/members/${memberId}/locker-passes/${passId}/locker`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
}

export async function stopProductPassById(token, memberId, passId, data) {
  return await mainCaller(`admin/api/v1/members/${memberId}/product-passes/${passId}/stop`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

export async function stopCancelProductPassById(token, memberId, passId, data = null) {
  return await mainCaller(`admin/api/v1/members/${memberId}/product-passes/${passId}/cancel-stop`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 수강권/이용권/라커/일반상품을 한 번에 동일 기간으로 중지 — 한 항목이라도 실패하면 전체 롤백된다.
export async function bulkStopMemberPasses(token, memberId, data) {
  return await mainCaller(`admin/api/v1/members/${memberId}/passes/bulk-stop`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
}

// 이미 중지된(STOPPED) 일반상품(운동복)의 중지기간 수정.
export async function modifyStopProductPassById(token, memberId, passId, data) {
  return await mainCaller(`admin/api/v1/members/${memberId}/product-passes/${passId}/stop`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
}


